import { object, string, number, array } from 'yup';

export default {
  validation: object().shape({
    email: string().email(),
    firstName: string(),
    lastName: string(),
    roles: array().of(object().shape({})).nullable(),
    filteringRules: array().of(object().shape({})).nullable(),
    timezoneId: number().nullable(),
  }),
  requireValues: ['email', 'firstName', 'lastName', 'roles'],
};
